import type { I18nFn } from '#/i18n/types/I18nFn';

export function EXPECTED_TIMES_RECURRING(i18n: I18nFn) {
  return [
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few hours per week'),
      id: 'FEW_HOURS_WEEK',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('A few hours per month'),
      id: 'FEW_HOURS_MONTH',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('Part time (10-30 hrs/wk)'),
      id: 'PART_TIME',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('Full time (30+ hrs/wk)'),
      id: 'FULL_TIME',
    },
    {
      /* TRANSLATORS: Form option for volop time commitment */
      name: i18n('Flexible'),
      id: 'FLEXIBLE',
    },
  ];
}
